module.exports = __webpack_public_path__ + "img/pt_tt.8064f1ef.png";